import React from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import {Typography} from '@material-ui/core';
import {Link} from 'react-router-dom';

const OGLTable = ({Tract}) => {
  const commonWidth = '15%'
  const commonHeight = '30px'
    const columns = [
        {
            title: 'Lease',
            field: 'Lease.leaseName',
            render: (rowData) => {
                return (
                    <Link to={`/Leases/${rowData.Lease.id}?name=${encodeURIComponent(rowData.Lease.leaseName)}`} target={'_blank'}>
                        {rowData.Lease.leaseName}
                    </Link>
                );
            },
        },
        {
            title: 'Status',
            field: 'Lease.status',
          cellStyle: {
            width: commonWidth,
            height: commonHeight,
            overflow: 'auto',
          },
        },
        {
            title: 'NSA',
            field: 'netSurfaceAcres',
          cellStyle: {
            width: commonWidth,
            height: commonHeight,
            overflow: 'auto',
          },
        },
        {
            title: 'NMA',
            field: 'netMineralAcres',
          cellStyle: {
            width: commonWidth,
            height: commonHeight,
            overflow: 'auto',
          },
        },
        {
            title: 'Lessee',
            field: 'Lease.currentLessee',
          cellStyle: {
            width: commonWidth,
            height: commonHeight,
            overflow: 'auto',
          },
        },
    ];

    const data = Tract.interest;
    return (
            <MaterialTable
                columns={columns}
                data={data.map(c => ({...c}))}
                options={{
                  paging: false,
                  search: false,
                  // maxBodyHeight: 'calc(100vh - 150px)',
                  // // searchFieldAlignment: 'left',
                  // // searchFieldStyle: {
                  // //   backgroundColor: '#fff',
                  // //   color: '#000',
                  // //   border: 'none',
                  // //   padding: '4px 8px',
                  // //   borderRadius: '4px',
                  // // },
                  showTitle: false,
                  // toolbarButtonAlignment: 'left',
                  // addRowPosition: 'first',
                  exportButton: false,
                  headerStyle: {
                    backgroundColor: '#1976d2',
                    color: '#FFF',
                    textAlign: 'left',
                    justifyContent: 'center',
                    whiteSpace: 'pre',
                },
              }}
              components={{
                Toolbar: (props) => (
                  <div
                    style={{
                      height: 16,
                      width:"100%",
                      marginTop: -30,
                      backgroundColor: '#1976d2',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      position: 'sticky',
                      top: 0,
                      zIndex: 20,
                    }}
                  >
                    <MTableToolbar {...props} />
                  </div>
                ),
              }}
            />
          );
          };

export default OGLTable;
